import { render } from "./ExportExcel.vue?vue&type=template&id=5e0b5854"
import script from "./ExportExcel.vue?vue&type=script&lang=ts"
export * from "./ExportExcel.vue?vue&type=script&lang=ts"

import "./ExportExcel.vue?vue&type=style&index=0&id=5e0b5854&lang=scss"
script.render = render

export default script